import type { ScreeningOutcomeProps } from './types'

export const OUTCOME_TO_TYPOGRAPHY_CLASS: Record<
  ScreeningOutcomeProps['outcome'],
  string
> = {
  'Low Risk': '!text-content-positive-dark',
  'Mixed Risk': '!text-content-warning-dark',
  'High Risk': '!text-content-alert-dark',
}

export const OUTCOME_TO_STROKE_CLASS: Record<
  ScreeningOutcomeProps['outcome'],
  string
> = {
  'Low Risk': 'stroke-content-positive-default',
  'Mixed Risk': 'stroke-content-warning-default',
  'High Risk': 'stroke-content-alert-default',
}
